import keyBy from 'lodash/keyBy'
import Vue from 'vue';

import {
  apiLoadSelectedPatientList,
  apiLoadPatientList,
  apiLoadSelectedPatientCases,
  apiAddNewPatient,
  apiAddNewPatientCase,
  apiUpdatePatientCase,
  apiUpdatePatientInfo,
  apiClosePatientCase,
  apiReopenPatientCase,
  apiLoadAdmittedPatientCount,
  apiLoadAllPatientCount,
  apiLoadPatientWithOpenCaseCount,
  apiLoadPatientCaseList,
  apiLoadAllPatientCasesCount,
  apiAddNewPatientCaseInfo,
  apiUpdatePatientCaseInfo, apiLoadSelectedPatientCaseList,
  apiArchivePatientCase,
  apiUnarchivePatientCase
} from '../api/apiObservables';

import {transformArrayModelsToObject} from '../../utilities/utilityOperators'

import apiHelper from '../../utilities/apiObsHelpers'

export const GETTER_PATIENT_CASES    = 'patients/getPatientCases';
export const GETTER_PATIENTS         = 'patients/getPatients';
export const GETTER_SELECTED_PATIENT = 'patients/getSelectedPatient';

export const GETTER_SELECTED_PATIENT_CASE = 'patients/getSelectedPatientCase';

export const ACTION_SAVE_PATIENT_MEDICAL_HISTORY = 'patients/actionSaveMedicalHistory';
export const ACTION_SAVE_GYNE_FORM      = 'patients/saveGyneForm';
export const ACTION_ADD_CASE_FORM       = 'patients/addCaseForm';
export const ACTION_SAVE_CASE_FORM      = 'patients/saveCaseForm';
export const ACTION_CLOSE_PATIENT_CASE  = 'patients/closePatientCase';
export const ACTION_REOPEN_PATIENT_CASE = 'patients/reopenPatientCase';

export const ACTION_ADD_PATIENT_CASE    = 'patients/addPatientCase';
export const ACTION_SAVE_PATIENT_CASE   = 'patients/savePatientCase';
export const ACTION_LOAD_PATIENT_CASE_INFO   = 'patients/loadPatientCaseInfo';

export const ACTION_ADD_PATIENT         = 'patients/addPatient';
export const ACTION_SAVE_PATIENT        = 'patients/savePatient';
export const ACTION_LOAD_PATIENT_INFO   = 'patients/loadPatientInfo';
export const ACTION_LOAD_PATIENT_LIST   = 'patients/loadPatientList';
export const ACTION_LOAD_PATIENT_CASES  = 'patients/loadCaseForm';

export const ACTION_LOAD_PATIENT_CASES_LIST   = 'patients/loadPatientCaseList';

export const ACTION_LOAD_PATIENT_COUNT          = 'patients/loadPatientCount';
export const ACTION_LOAD_ADMITTED_PATIENT_COUNT = 'patients/loadAdmittedPatientCount';
export const ACTION_LOAD_OPENCASE_PATIENT_COUNT = 'patients/loadPatientWithOpenCaseCount';

export const ACTION_LOAD_PATIENT_CASES_COUNT     = 'patients/loadPatientCasesCount';

export const ACTION_ARCHIVE_PATIENT_CASE        = 'patients/archivePatientCase';
export const ACTION_UNARCHIVE_PATIENT_CASE      = 'patients/unarchivePatientCase';

export const MUTATE_SET_ALL_PATIENT_CASES        = 'patients/setAllPatientCases';

export const MUTATE_SET_ALL_PATIENTS             = 'patients/setAllPatients';
export const MUTATE_SET_PATIENT                  = 'patients/setPatient';
export const MUTATE_SET_PATIENT_CASES            = 'patients/setCases';
export const MUTATE_SAVE_PATIENT_MEDICAL_HISTORY = 'patients/mutateSaveMedicalHistory';
export const MUTATE_ADD_PATIENT_CASE             = 'patients/addPatientCase';

export const MUTATE_ADD_PATIENT = 'patients/setNewPatient';

export const MUTATE_SET_SELECTED_PATIENT_PROPERTY = 'patients/setSelectedPatientProperty';
export const MUTATE_SET_SELECTED_PATIENT_CASE_PROPERTY = 'patients/setSelectedPatientCaseProperty';

export const ACTION_LOAD_PATIENT_LIST_NEXTPAGE   = 'patients/loadPatientListNextPage';
export const MUTATE_SET_PATIENT_NEXTPAGE = 'patients/setPatientListNextPage';

export const ACTION_LOAD_PATIENT_CASE_LIST_NEXTPAGE   = 'patients/loadPatientCaseListNextPage';
export const MUTATE_SET_PATIENT_CASE_NEXTPAGE = 'patients/setPatientCaseListNextPage';

export const MUTATE_ARCHIVE_CASE = 'patients/mutateArchiveCase';
export const MUTATE_UNARCHIVE_CASE = 'patients/mutateUnarchiveCase';

const state = {
  patients: {},
  patientcases: {},
  selectedPatient: {
    info: null,
    cases : null
  },
  selectedPatientCase: {}
};

const getters = {
  [GETTER_PATIENT_CASES]: (state) => Object.values(state.patientcases),
  [GETTER_PATIENTS]: (state) => Object.values(state.patients),
  [GETTER_SELECTED_PATIENT]: (state) => state.selectedPatient,
  [GETTER_SELECTED_PATIENT_CASE]: (state) => state.selectedPatientCase
};

const mutations = {

  [MUTATE_ADD_PATIENT]: (state, payload) => {
    payload.patientid = '000' + Object.keys(state.patients).length;
    Vue.set(state.patients, payload.patientid, payload);
  },
  [MUTATE_SAVE_PATIENT_MEDICAL_HISTORY]: (state, {patientId, medicalHistory}) => {
    let result = state.patients[patientId];
    if (result) Vue.set(result, 'medicalHistory', medicalHistory);
  },
  [MUTATE_ADD_PATIENT_CASE]: (state, {patientId, model}) => {
    const patient = state.patients[patientId];
    if (patient) {
      if (model.Id && patient.cases[model.Id]) {
        patient.cases[model.Id] = Object.assign({}, model);
      } else {
        const key = Object.keys(patient.cases) + 1;
        Vue.set(patient.cases, key, Object.assign({}, model, {Id: key}));
      }
    }
  },
  [MUTATE_SET_PATIENT] : (state, payload) => {
    state.selectedPatient = payload
    Vue.set(state.selectedPatient,"cases",[])
  },
  [MUTATE_SET_PATIENT_CASES]: (state, payload) => {
    Vue.set(state.selectedPatient, "cases", payload)
  },
  [MUTATE_SET_ALL_PATIENTS]: (state, payload) => {
      state.patients = payload;
  },
  [MUTATE_SET_ALL_PATIENT_CASES]:(state, payload) => {
    state.patientcases = payload;
  },
  [MUTATE_SET_SELECTED_PATIENT_PROPERTY]: (state, {key, value}) => {
    state.selectedPatient[key] = value;
  },
  [MUTATE_SET_SELECTED_PATIENT_CASE_PROPERTY]: (state, {key, value}) => {
    state.selectedPatientCase[key] = value;
  },
  [MUTATE_SET_PATIENT_NEXTPAGE] : (state, payload) => {
    const patientids = Object.keys(payload);
    patientids.forEach(id => {
      Vue.set(state.patients, id, payload[id]);
    })
  },
  [MUTATE_SET_PATIENT_CASE_NEXTPAGE] : (state, payload) => {
    const caseids = Object.keys(payload);
    caseids.forEach(id => {
      Vue.set(state.patientcases, id, payload[id]);
    })
  },

  [MUTATE_ARCHIVE_CASE]: (state, updatedCase) => {
    if (updatedCase._id && state.patientcases[updatedCase._id]) {
      Vue.set(state.patientcases, updatedCase._id, updatedCase);
    }
  },
  [MUTATE_UNARCHIVE_CASE]: (state, updatedCase) => {
    if (updatedCase._id && state.patientcases[updatedCase._id]) {
      Vue.set(state.patientcases, updatedCase._id, updatedCase);
    }
  },
};

const actions = {
  [ACTION_SAVE_PATIENT_MEDICAL_HISTORY]: (context, payload) => {
    context.commit(MUTATE_SAVE_PATIENT_MEDICAL_HISTORY, payload);
  },
  [ACTION_SAVE_GYNE_FORM]: (context, payload) => {
    context.commit(MUTATE_ADD_PATIENT_CASE, payload);
  },
  [ACTION_ADD_CASE_FORM]: apiHelper.mutateResult(apiAddNewPatientCase),
  [ACTION_SAVE_CASE_FORM] : apiHelper.mutateResult(apiUpdatePatientCase),
  [ACTION_ADD_PATIENT] : apiHelper.mutateResult(apiAddNewPatient),
  [ACTION_ADD_PATIENT_CASE] : apiHelper.mutateResult(apiAddNewPatientCaseInfo),

  [ACTION_LOAD_PATIENT_CASE_INFO] : apiHelper.mutateResult(
    apiLoadSelectedPatientCaseList,
    MUTATE_SET_SELECTED_PATIENT_CASE_PROPERTY,
    (data) => ({ key: 'info', value: data }) ),

  [ACTION_LOAD_PATIENT_INFO] : apiHelper.mutateResult(
    apiLoadSelectedPatientList,
    MUTATE_SET_SELECTED_PATIENT_PROPERTY,
    (data) => ({ key: 'info', value: data }) ),
  [ACTION_LOAD_PATIENT_CASES] : apiHelper.mutateResult(
    apiLoadSelectedPatientCases,
    MUTATE_SET_SELECTED_PATIENT_PROPERTY,
    (data) => ({ key: 'cases', value: data.map( (v) => transformArrayModelsToObject(v)) }) ),
  [ACTION_LOAD_PATIENT_LIST] : apiHelper.mutateResult(
      apiLoadPatientList,
      MUTATE_SET_ALL_PATIENTS,
      (data) => keyBy(data, '_id')),
  [ACTION_LOAD_PATIENT_CASES_LIST] : apiHelper.mutateResult(
    apiLoadPatientCaseList,
    MUTATE_SET_ALL_PATIENT_CASES,
    (data) => keyBy(data, '_id')),
  [ACTION_SAVE_PATIENT] : apiHelper.mutateResult(apiUpdatePatientInfo),

  [ACTION_SAVE_PATIENT_CASE] : apiHelper.mutateResult(apiUpdatePatientCaseInfo),

  [ACTION_CLOSE_PATIENT_CASE] : apiHelper.mutateResult(apiClosePatientCase),
  [ACTION_REOPEN_PATIENT_CASE] : apiHelper.mutateResult(apiReopenPatientCase),

  [ACTION_LOAD_PATIENT_CASES_COUNT] : apiHelper.mutateResult(apiLoadAllPatientCasesCount),

  [ACTION_LOAD_PATIENT_COUNT] : apiHelper.mutateResult(apiLoadAllPatientCount),
  [ACTION_LOAD_ADMITTED_PATIENT_COUNT] : apiHelper.mutateResult(apiLoadAdmittedPatientCount),
  [ACTION_LOAD_OPENCASE_PATIENT_COUNT] : apiHelper.mutateResult(apiLoadPatientWithOpenCaseCount),
  [ACTION_LOAD_PATIENT_LIST_NEXTPAGE] : apiHelper.mutateResult(
    apiLoadPatientList,
    MUTATE_SET_PATIENT_NEXTPAGE,
    (data) => keyBy(data, '_id')),
  [ACTION_LOAD_PATIENT_CASE_LIST_NEXTPAGE] : apiHelper.mutateResult(
    apiLoadPatientCaseList,
    MUTATE_SET_PATIENT_CASE_NEXTPAGE,
    (data) => keyBy(data, '_id')),

  [ACTION_ARCHIVE_PATIENT_CASE]: apiHelper.mutateResult(
      apiArchivePatientCase,
      MUTATE_ARCHIVE_CASE,
      (data) => data
  ),
  [ACTION_UNARCHIVE_PATIENT_CASE]: apiHelper.mutateResult(
      apiUnarchivePatientCase,
      MUTATE_UNARCHIVE_CASE,
      (data) => data
  ),
};

export default {
  state,
  getters,
  mutations,
  actions
}
